/* @flow strict */

import * as React from 'react';
import DataTable from 'react-data-table-component';
import ReactTooltip from 'react-tooltip';

type PropsType = {
  vip_codes: [],
  toggledClearRows: boolean,
  handleSelectRow: () => void,
  eventId: number | string,
  isReadOnly: boolean
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  },
  rows: {
    style: {
      flexShrink: '0'
    }
  }
};

let mock = {
  columns: []
};

const EventPageDetailVIPCodesBody = (
  {
    vip_codes,
    toggledClearRows,
    handleSelectRow,
    eventId,
    isReadOnly
  }: PropsType): React.Element<'div'> => {
  try {
    mock = require('./tableHeaders/index.js');
  } catch (e) {
    console.warn('File "./tableHeaders/index.js" doesn\'t exist');
  }

  const columns = mock.columns(eventId);

  if (isReadOnly) {
    columns.shift();
  }

  return (
    <div className="panel-body">
      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <ReactTooltip
            place="right"
            type="light"
            effect="solid"
            multiline
            border
            borderColor='#ddd'
            backgroundColor='white'
            className='ReactTooltipCustom'
          />
          <DataTable
            columns={columns}
            data={vip_codes}
            customStyles={customStyles}
            selectableRows={!isReadOnly} // add for checkbox selection
            Clicked
            onSelectedRowsChange={(selected: any) => {
              handleSelectRow(selected);
            }}
            clearSelectedRows={toggledClearRows}
            selectableRowsHighlight
            pagination={_.size(vip_codes) > 10}
            highlightOnHover
            responsive
            striped
            fixedHeader
            noHeader
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EventPageDetailVIPCodesBody;
